import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1300VertragsendeStatus: 'idle',
    startProcess1300VertragsendeError: undefined as any,
    loadUserParamsProcess1300VertragsendeStatus: 'idle',
    loadUserParamsProcess1300VertragsendeError: undefined as any,
    stammIni_VertragswechselFeldKeinRestantAktivStatus: 'idle',
    stammIni_VertragswechselFeldKeinRestantAktivError: undefined as any,
    stammIni_VtgEndeEinzugEntziehenfalseStatus: 'idle',
    stammIni_VtgEndeEinzugEntziehenfalseError: undefined as any,

    process1300VertragsendeList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    stammIni_VertragswechselFeldKeinRestantAktiv: undefined as any,
    stammIni_VtgEndeEinzugEntziehenfalse: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1300Vertragsende = createAsyncThunk('process1300VertragsendeSlice/startProcess1300Vertragsende', async ({ process1300Vertragsende }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1300Vertragsende/`,
        prepareData(process1300Vertragsende),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1300VertragsendeStatus } = getState().process1300VertragsendeSlice
        return startProcess1300VertragsendeStatus !== 'pending'
    }
})

export const loadUserParamsProcess1300Vertragsende = createAsyncThunk('process1300VertragsendeSlice/loadUserParamsProcess1300Vertragsende', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1300Vertragsende/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1300VertragsendeStatus } = getState().process1300VertragsendeSlice
        return loadUserParamsProcess1300VertragsendeStatus !== 'pending'
    }
})

export const stammIni_VertragswechselFeldKeinRestantAktiv = createAsyncThunk('process1300VertragsendeSlice/stammIni_VertragswechselFeldKeinRestantAktiv', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VertragswechselFeldKeinRestantAktiv/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { stammIni_VertragswechselFeldKeinRestantAktivStatus } = getState().process1300VertragsendeSlice
        return stammIni_VertragswechselFeldKeinRestantAktivStatus !== 'pending'
    }
})

export const stammIni_VtgEndeEinzugEntziehenfalse = createAsyncThunk('process1300VertragsendeSlice/stammIni_VtgEndeEinzugEntziehenfalse', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_VtgEndeEinzugEntziehenfalse/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { stammIni_VtgEndeEinzugEntziehenfalseStatus } = getState().process1300VertragsendeSlice
        return stammIni_VtgEndeEinzugEntziehenfalseStatus !== 'pending'
    }
})

const Process1300VertragsendeSlice = createSlice({
    name: 'process1300VertragsendeSlice',
    initialState,
    reducers: {
        resetstartProcess1300Vertragsende: (state) => {
            state.job = undefined
            state.startProcess1300VertragsendeError = undefined
        },
        resetstartProcess1300VertragsendeError: (state) => {
            state.startProcess1300VertragsendeError = undefined
        },
        resetloadUserParamsProcess1300Vertragsende: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1300VertragsendeError = undefined
        },
        resetloadUserParamsProcess1300VertragsendeError: (state) => {
            state.loadUserParamsProcess1300VertragsendeError = undefined
        },
        resetstammIni_VertragswechselFeldKeinRestantAktiv: (state) => {
            state.stammIni_VertragswechselFeldKeinRestantAktiv = undefined
            state.stammIni_VertragswechselFeldKeinRestantAktivError = undefined
        },
        resetstammIni_VertragswechselFeldKeinRestantAktivError: (state) => {
            state.stammIni_VertragswechselFeldKeinRestantAktivError = undefined
        },
        resetstammIni_VtgEndeEinzugEntziehenfalse: (state) => {
            state.stammIni_VtgEndeEinzugEntziehenfalse = undefined
            state.stammIni_VtgEndeEinzugEntziehenfalseError = undefined
        },
        resetstammIni_VtgEndeEinzugEntziehenfalseError: (state) => {
            state.stammIni_VtgEndeEinzugEntziehenfalseError = undefined
        },
        removeFromProcess1300VertragsendeListById: (state, action) => {
            state.process1300VertragsendeList = state.process1300VertragsendeList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1300VertragsendeListByIds: (state, action) => {
            state.process1300VertragsendeList = state.process1300VertragsendeList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1300VertragsendeList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1300VertragsendeStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1300VertragsendeList = []
            state.startProcess1300VertragsendeStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1300Vertragsende.pending, (state) => {
            state.startProcess1300VertragsendeStatus = 'pending'
            state.startProcess1300VertragsendeError = undefined
        })
        builder.addCase(startProcess1300Vertragsende.fulfilled, (state, action) => {
            state.startProcess1300VertragsendeStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1300Vertragsende.rejected, (state, action) => {
            state.startProcess1300VertragsendeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1300VertragsendeError = action.error.message
            } else {
                state.startProcess1300VertragsendeError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1300Vertragsende.pending, (state) => {
            state.loadUserParamsProcess1300VertragsendeStatus = 'pending'
            state.loadUserParamsProcess1300VertragsendeError = undefined
        })
        builder.addCase(loadUserParamsProcess1300Vertragsende.fulfilled, (state, action) => {
            state.loadUserParamsProcess1300VertragsendeStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1300Vertragsende.rejected, (state, action) => {
            state.loadUserParamsProcess1300VertragsendeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1300VertragsendeError = action.error.message
            } else {
                state.loadUserParamsProcess1300VertragsendeError = action.payload
            }
        })

        builder.addCase(stammIni_VertragswechselFeldKeinRestantAktiv.pending, (state) => {
            state.stammIni_VertragswechselFeldKeinRestantAktivStatus = 'pending'
            state.stammIni_VertragswechselFeldKeinRestantAktivError = undefined
        })
        builder.addCase(stammIni_VertragswechselFeldKeinRestantAktiv.fulfilled, (state, action) => {
            state.stammIni_VertragswechselFeldKeinRestantAktivStatus = 'idle'

            {
                state.stammIni_VertragswechselFeldKeinRestantAktiv = action.payload

            }
        })
        builder.addCase(stammIni_VertragswechselFeldKeinRestantAktiv.rejected, (state, action) => {
            state.stammIni_VertragswechselFeldKeinRestantAktivStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.stammIni_VertragswechselFeldKeinRestantAktivError = action.error.message
            } else {
                state.stammIni_VertragswechselFeldKeinRestantAktivError = action.payload
            }
        })

        builder.addCase(stammIni_VtgEndeEinzugEntziehenfalse.pending, (state) => {
            state.stammIni_VtgEndeEinzugEntziehenfalseStatus = 'pending'
            state.stammIni_VtgEndeEinzugEntziehenfalseError = undefined
        })
        builder.addCase(stammIni_VtgEndeEinzugEntziehenfalse.fulfilled, (state, action) => {
            state.stammIni_VtgEndeEinzugEntziehenfalseStatus = 'idle'

            {
                state.stammIni_VtgEndeEinzugEntziehenfalse = action.payload

            }
        })
        builder.addCase(stammIni_VtgEndeEinzugEntziehenfalse.rejected, (state, action) => {
            state.stammIni_VtgEndeEinzugEntziehenfalseStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.stammIni_VtgEndeEinzugEntziehenfalseError = action.error.message
            } else {
                state.stammIni_VtgEndeEinzugEntziehenfalseError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1300Vertragsende,
    resetstartProcess1300VertragsendeError,
    resetloadUserParamsProcess1300Vertragsende,
    resetloadUserParamsProcess1300VertragsendeError,
    resetstammIni_VertragswechselFeldKeinRestantAktiv,
    resetstammIni_VertragswechselFeldKeinRestantAktivError,
    resetstammIni_VtgEndeEinzugEntziehenfalse,
    resetstammIni_VtgEndeEinzugEntziehenfalseError,
    removeFromProcess1300VertragsendeListById,
    removeFromProcess1300VertragsendeListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1300VertragsendeSlice.actions
export default Process1300VertragsendeSlice.reducer
